import { FormProvider } from 'contexts'
import React from 'react'

export function FormContext ({ children }) {
  return <FormProvider>{children}</FormProvider>
}

export default FormContext
